// src/layouts/CompetitionsLayout.jsx

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import MinimalLogo from '@/components/ui/MinimalLogo';
import { useTenant } from '@/contexts/TenantContext';

// ✅ New: import avatar icon component
import AvatarMenu from '@/components/ui/AvatarMenu';

const CompetitionsLayout = ({ children }) => {
  const location = useLocation(); // ✅ Used to highlight active navigation link based on URL
  const { branding, tenant } = useTenant();    

  return (
    <div className="min-h-screen w-screen bg-stone-brown text-swan">
      {/* 
        Page Wrapper
        - min-h-screen: ensures full viewport height
        - w-screen: full viewport width
        - bg-stone-brown: background color matching Zelospace dark theme
        - text-swan: soft white base text color
      */}

      {/* Top Navigation Bar */}
      <header className="fixed top-0 left-0 w-full z-50 flex items-center justify-between px-6 py-3 shadow-md bg-stone-brown">
        {/* 
          Navigation Bar
          - flex items-center justify-between: logo on left, nav + avatar on right
          - px-6 py-3: tighter padding for clean navbar
          - shadow-md: gives subtle divider look
        */}

        {/* Logo (left side) */}
        <Link to="/competitions" className="flex items-center gap-3">
          {branding?.logo_url ? (
            <>
              <img
                src={branding.logo_url}
                alt={tenant?.name ?? 'Partner'}
                className="h-8 w-auto object-contain rounded"
              />
            </>
          ) : (
            <MinimalLogo className="h-10" />
          )}
        </Link>

        {/*  Page Navigation */}
        <div className="flex items-center gap-2">
          {/* 
            - flex: horizontal layout
            - gap-2: spacing between nav links
          */}

          {/* Events link (optional second nav item) */}
          <Link
            to="/events"
            className={`nav-text font-semibold hover:text-mikado-yellow ${
              location.pathname.startsWith('/events') ? 'text-mikado-yellow' : ''
            }`}
          >
            Events
          </Link>

          <Link
            to="/hof"
            className={`nav-text font-semibold hover:text-mikado-yellow ${
              location.pathname.startsWith('/hof') ? 'text-mikado-yellow' : ''
            }`}
          >
            Hall of Fame
          </Link>

        </div>
        {/* ✅ New: Avatar menu (icon for profile) */}
        <AvatarMenu />
      </header>

      {/* Main Content */}
      <main className="overflow-y-auto h-[calc(100dvh)] px-6">
        {children}
      </main>
    </div>
  );
};

export default CompetitionsLayout;